import {
  Boxes,
  Smartphone,
  BrainCircuit,
  CloudCog,
  RefreshCcw,
  Compass,
  Rocket,
  TabletSmartphone,
  Workflow,
  Sparkles,
  Wrench,
  CloudUpload,
} from "lucide-react";

export const services = [
  {
    slug: "software-product-development",
    title: "Software & Product Development",
    short: "Software Development",
    menuDesc: "Products, platforms, APIs and business applications.",
    desc: "Build reliable software products, platforms, APIs, and business applications designed around your goals and long-term growth.",
    icon: Boxes,
  },
  {
    slug: "web-mobile-development",
    title: "Web & Mobile Development",
    short: "Web & Mobile",
    menuDesc: "Fast, scalable web and mobile experiences.",
    desc: "Create fast, intuitive, and scalable web and mobile experiences designed for customers, teams, and modern digital businesses.",
    icon: Smartphone,
  },
  {
    slug: "ai-data-automation",
    title: "AI, Data & Automation",
    short: "AI & Automation",
    menuDesc: "Intelligence applied to real workflows.",
    desc: "Apply artificial intelligence, data, and automation to streamline workflows, improve decisions, and create smarter digital experiences.",
    icon: BrainCircuit,
  },
  {
    slug: "cloud-infrastructure",
    title: "Cloud & Infrastructure",
    short: "Cloud & Infrastructure",
    menuDesc: "Cloud environments built for reliability.",
    desc: "Build and modernize cloud environments, hosting systems, deployment pipelines, and infrastructure designed for performance and reliability.",
    icon: CloudCog,
  },
  {
    slug: "digital-transformation",
    title: "Digital Transformation",
    short: "Digital Transformation",
    menuDesc: "Modernise processes, systems and operations.",
    desc: "Modernize processes, systems, and digital operations through thoughtful technology integration and automation.",
    icon: RefreshCcw,
  },
  {
    slug: "technology-consulting",
    title: "Technology Consulting",
    short: "Technology Consulting",
    menuDesc: "Architecture, strategy and technical guidance.",
    desc: "Get practical technical guidance across architecture, software strategy, integrations, scalability, testing, and implementation.",
    icon: Compass,
  },
];

export const solutionsMenu = [
  {
    title: "For Startups",
    slug: "startups",
    desc: "MVP to scalable product, engineered right.",
    icon: Rocket,
  },
  {
    title: "SaaS Product Development",
    slug: "saas",
    desc: "Architecture, APIs and infrastructure to grow.",
    icon: Boxes,
  },
  {
    title: "Business Automation",
    slug: "business-automation",
    desc: "Replace repetitive work with integrated systems.",
    icon: Workflow,
  },
  {
    title: "AI Integration",
    slug: "ai-integration",
    desc: "Intelligent features inside products and operations.",
    icon: Sparkles,
  },
  {
    title: "Cloud Modernization",
    slug: "cloud-modernization",
    desc: "Reliable, scalable cloud environments.",
    icon: CloudUpload,
  },
];

export const solutions = [
  {
    title: "Launch a SaaS Product",
    desc: "Turn an idea into a scalable web-based product with the architecture, interfaces, APIs, and infrastructure needed to grow.",
    icon: Rocket,
  },
  {
    title: "Build a Mobile Application",
    desc: "Design and develop mobile experiences for customers, internal teams, or digital-first businesses.",
    icon: TabletSmartphone,
  },
  {
    title: "Automate Business Processes",
    desc: "Replace repetitive workflows and disconnected processes with integrated systems and intelligent automation.",
    icon: Workflow,
  },
  {
    title: "Integrate AI",
    desc: "Bring AI into products or internal operations through intelligent features, workflow automation, and data-driven capabilities.",
    icon: Sparkles,
  },
  {
    title: "Modernize Existing Systems",
    desc: "Improve aging applications, infrastructure, or workflows without rebuilding everything from scratch.",
    icon: Wrench,
  },
  {
    title: "Move to the Cloud",
    desc: "Design and implement modern cloud environments that improve reliability, deployment, and scalability.",
    icon: CloudUpload,
  },
];

export const principles = [
  {
    title: "Built for Scalability",
    desc: "Architecture and engineering decisions are made with growth, maintainability, and long-term use in mind.",
  },
  {
    title: "Product-Focused Thinking",
    desc: "We consider the complete product experience — from functionality and usability to performance and future evolution.",
  },
  {
    title: "Modern Engineering",
    desc: "We use technologies and development practices that fit the problem rather than forcing every project into the same stack.",
  },
  {
    title: "Long-Term Reliability",
    desc: "Good technology should remain dependable after launch, with clear foundations for maintenance and continuous improvement.",
  },
];

export const processSteps = [
  {
    num: "01",
    title: "Discover",
    desc: "Understand the problem, users, requirements, priorities, and business objectives.",
  },
  {
    num: "02",
    title: "Design",
    desc: "Shape the experience, architecture, workflows, and technical direction.",
  },
  {
    num: "03",
    title: "Build",
    desc: "Engineer, test, integrate, and refine the solution through structured development.",
  },
  {
    num: "04",
    title: "Scale",
    desc: "Launch, monitor, maintain, optimize, and evolve the technology as requirements grow.",
  },
];

export const capabilities = [
  "Software Engineering",
  "Web & Mobile",
  "SaaS",
  "Cloud",
  "AI & Automation",
  "Digital Transformation",
];

export const engineeringAreas = [
  "Modern Architecture",
  "Cloud-Native Infrastructure",
  "API-First Integrations",
  "Automation & AI",
];

export const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Refund & Cancellation Policy", to: "/refund-cancellation-policy" },
  { label: "Shipping & Delivery Policy", to: "/shipping-delivery-policy" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Disclaimer", to: "/disclaimer" },
];

export const contact = {
  email: "hello@bytevora.com",
  phone: "+91 93053 83099",
  phoneHref: "tel:+919305383099",
  location: "Lucknow, Uttar Pradesh, India",
  registeredOffice: "D-46, Vibhuti Khand, Gomtinagar, Lucknow, Uttar Pradesh – 226010",
  cin: "U62091UP2026PTC251666",
  gst: "09AAPCB0689L1ZY",
  legalName: "Bytevora IT Solutions Private Limited",
};
